"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Watch = void 0;
var Observable_1 = require("./Observable");
/**
 * Observes a property and runs a callback whenever it's modified.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function Watch(opts) {
    /* eslint-enable @typescript-eslint/naming-convention, max-len */
    // Default options
    var options = typeof opts == 'object' ? opts : {
        prop: opts
    };
    // Implementation
    function decorator(target, name) {
        (0, Observable_1.makePropertyObservable)(target, options.prop);
        var unregister = (0, Observable_1.registerHandler)(target, options.prop, function (value) {
            target[name].call(this, value);
        });
    }
    return decorator;
}
exports.Watch = Watch;
//# sourceMappingURL=Watch.js.map